<template>

    <div>
        <h2 class="h5">Québec&nbsp;:</h2>
        <div class="form-group">
            <div class="checkbox">
                <label>
                    <input type="checkbox"
                           ref="checkbox"
                           class="checkbox-input"
                           value="1"
                           :checked="isChecked"
                           @change.stop="onChange"
                           :autofocus="initialFocus"
                    />
                    {{ label }}
                </label>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'multiple-select-enabler',

    props: {
        source: String,
        label: String,
        initialFocus: Boolean,
    },

    computed: {
        ...mapState({
            isChecked (state)
            {
                return state[this.source];
            },
        }),
    },

    methods: {
        isNodeChecked ()
        {
            if (window.$)
            {
                // Make this cross-browser compatible:
                return window.$(this.$refs.checkbox).is(':checked');
            }
            return null;
        },

        onChange ()
        {
            if (this.isNodeChecked())
            {
                this.$store.dispatch('SET_ALL_PROVINCE_CHECKBOX', [
                    true,
                ]);
            }
            else
            {
                this.$store.dispatch('SET_ALL_PROVINCE_CHECKBOX', [
                    false,
                ]);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/multiple-select-enabler.vue